// extracted by mini-css-extract-plugin
module.exports = {"title-wr":"icon__title-wr___1U8nu"};